<script setup lang="ts">
    import { toRefs } from "vue";
    import { anmalanStatusIcons } from "@/tabs/Operation/utilsTs";
    import { computed } from "vue";

    const props = withDefaults(
        defineProps<{
            content?: string;
            contentDirection?: "vertical" | "horizontal";
            selected?: boolean;
            multiple?: boolean;
            useIcon?: boolean;
            statusIconKey?: string; // ladda status ikon src från statusIcons
            iconSrc?: string;
            onClick?: () => void;
        }>(),
        {
            contentDirection: "horizontal",
            multiple: false,
            selected: false,
            useIcon: false,
        }
    );

    const iconPath = computed(() => {
        return props.useIcon
            ? props.iconSrc || anmalanStatusIcons[props.statusIconKey as keyof typeof anmalanStatusIcons]
            : "";
    });

    const { onClick } = toRefs(props);

    const onListItemClick = () => {
        onClick?.value?.();
    };
</script>

<template>
    <li
        :class="['k-autocomplete-option', contentDirection, { multiple, selected, clickable: !!onClick }]"
        @click="onListItemClick"
    >
        <slot :contentDirection="contentDirection" :selected="selected">
            <div v-if="multiple" :class="['checkbox', { selected }]" />
            <span v-if="useIcon">
                <img :src="iconPath" :alt="content" class="icon" />
            </span>
            <span class="content">{{ content }}</span>
        </slot>
    </li>
</template>

<style lang="scss" scoped>
    @import "@/style/variables";

    .k-autocomplete-option {
        display: grid;
        grid-column-gap: 0.4rem;
        justify-content: start;
        align-items: start;

        &.vertical {
            grid-auto-flow: row;
        }

        &.horizontal {
            grid-auto-flow: column;
        }

        &.multiple {
            justify-content: flex-start;
            align-content: center;
            align-items: center;
        }

        .checkbox {
            border-radius: 6px;
            aspect-ratio: 1;
            height: 1.3rem;
            border: 1px solid $color-input-border;
        }

        &.selected {
            .checkbox {
                background: url("@/assets/checkmark_light.svg") 50% no-repeat;
                background-color: $color-default-blue;
            }

            .icon {
                margin-right: $icon-gap-default;
            }

            .content {
                align-self: self-start;
                display: inline-block;
                text-align: left !important;
            }
        }

        &.clickable {
            cursor: pointer;
        }
    }
</style>
